// Build identity, fetched once from /version.json at runtime.
// - prod: scripts/build-web.ts writes dist/version.json
// - dev:  server.ts serves a generated /version.json from git
// On fetch failure (offline, file missing) returns "dev".

export type Version = { sha: string; date: string };

let cached: Promise<Version> | null = null;

export function loadVersion(): Promise<Version> {
  if (!cached) {
    cached = fetch("/version.json")
      .then((r) => (r.ok ? (r.json() as Promise<Version>) : { sha: "dev", date: "" }))
      .catch(() => ({ sha: "dev", date: "" }));
  }
  return cached;
}
